import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Calendar, MessageCircle } from "lucide-react";

const WA = "919115423336";

export function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} · अन्वय Family Constellations` : "अन्वय · Family Constellation Therapy — Arjunna Soni";
  }, [title]);
}

export default function Layout({ children }) {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-parchment">
      <Navbar />
      <main className="pt-20 flex-1">{children}</main>
      <Footer />

      {/* Sticky mobile action bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 grid grid-cols-2 gap-px bg-hairline border-t hairline" data-testid="mobile-sticky-bar">
        <Link to="/book" className="bg-gold text-earth font-bold py-3.5 flex items-center justify-center gap-2 text-sm" data-testid="sticky-book-btn">
          <Calendar size={18} /> Book
        </Link>
        <a
          href={`https://wa.me/${WA}?text=${encodeURIComponent("Hi Arjunna, I'd like to know more about constellation work.")}`}
          target="_blank" rel="noreferrer"
          className="bg-earth text-parchment font-bold py-3.5 flex items-center justify-center gap-2 text-sm"
          data-testid="sticky-whatsapp-btn"
        >
          <MessageCircle size={18} /> WhatsApp
        </a>
      </div>
      <div className="md:hidden h-14" />
    </div>
  );
}
